import { User } from '@/app-modules/store/modules/user';
export class AuthenticationCommand {
    public userId: number;
    public crossCheck: number;
    public clubNumber: number;
    public siteId: number;
    public clientTypeId: number;

    constructor(user: User, clubNumber: number) {
        this.userId = user.userId;
        this.crossCheck = user.crosscheckId;
        this.clientTypeId = 1048;
        this.clubNumber = clubNumber;
        this.siteId = 6;
    }

    public toPayload() {
        let authString: string;
        authString = `<admin command="auth" clubNo="${this.clubNumber}" siteId="${this.siteId}" id="${this.userId}" clientTypeId="${this.clientTypeId}" crossCheck="${this.crossCheck}" chatmod="true" />`;
        return authString;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/auth/auth-command.ts